import { startTransition } from 'react';
import { useUiStore } from '../../../stores/uiStore';

/**
 * useClearDevFilters — shared "Clear all filters" handler.
 *
 * Brief 4 Commit 2 hoist. Originally inline in DevsBoardSummary.js:181-194;
 * extracted so the new <BarLeft /> chips Clear-all button in DevsActionBar
 * (Brief 4 Commit 2 mount site) calls the SAME function as the panel's
 * Clear all button. Per Convention #141 — both surfaces must literally
 * call the same function, not duplicate the body.
 *
 * Signature: returns the handler function directly. Consumers:
 *   const handleClearAll = useClearDevFilters();
 *   ... <button onClick={handleClearAll}>Clear all</button>
 *
 * Internal: byte-identical body to the prior DevsBoardSummary inline
 * version — same 7 Set keys (status, designer, type, material, shape,
 * factory, sunOptic), same startTransition wrap for React concurrency,
 * same devSearch reset.
 *
 * The `type` Set stays in the reset payload per Convention #74 minimal
 * scope — Brief 4 was not authorized to clean dead state in this commit.
 * If the `type` axis is later confirmed unused, a separate cleanup brief
 * can remove it from the uiStore initial state, this hook, and the
 * activeFilterCount derivation in DevsActionBar.js.
 *
 * Refs Brief E.1 (DevsBoardSummary introduction with inline handleClearAll),
 * Brief F.2.5 (shared canonical Set pattern, Convention #141),
 * Brief 4 Commit 2 (this hook hoist).
 */
export function useClearDevFilters() {
  const setDevFilters = useUiStore((s) => s.setDevFilters);
  const setDevSearch  = useUiStore((s) => s.setDevSearch);

  return () => {
    startTransition(() => {
      setDevFilters({
        status:   new Set(),
        designer: new Set(),
        type:     new Set(),
        material: new Set(),
        shape:    new Set(),
        factory:  new Set(),
        season:   new Set(),     // CLB-079 — Clear-all is a FULL reset; season was the one axis it missed
        sunOptic: new Set(),
        decision: new Set(),     // Task 4 — Selection decision filter
        procurement: new Set(),  // Task 4 — procurement (ORDER/PRE-ORDER) filter
      });
      setDevSearch('');
    });
  };
}
